const ITEMS = [
  "Divyanshi & Divyashiv",
  "26 · 11 · 2026",
  "Kesari Mangalam Lawn",
  "Kanpur",
];

function Sequence({ hidden }) {
  return (
    <div className="marquee-seq" aria-hidden={hidden || undefined}>
      {ITEMS.map((t) => (
        <span className="marquee-item" key={t}>
          {t}
          <span className="dia" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div className="marquee" data-testid="marquee-band">
      <div className="marquee-track">
        <Sequence />
        <Sequence hidden />
      </div>
    </div>
  );
}
